module.exports = __webpack_public_path__ + "img/maintenance.9c52b415.webp";